export default "__VITE_ASSET__DLKUCMWg__"